import { ErrorState } from '@/components/ui/States';
import { SkeletonRows } from '@/components/ui/Skeleton';
import { toast } from '@/components/ui/Toast';
import { ReviewQueue, DecidedList } from '@/components/review/ReviewQueue';
import { useCompanyRole } from '@/app/store';
import { useAsync } from '@/lib/useAsync';
import { api } from '@/lib/api';
import { useProjectCtx } from './ProjectLayout';

/** This project's slice of the workspace review queue. */
export function ProjectReviewTab() {
  const { company, workspace, project } = useProjectCtx();
  const role = useCompanyRole(company.id);
  const canDecide = role === 'STAFF' || role === 'ADMIN';

  const suggestions = useAsync(() => api.listSuggestions(workspace.id), [workspace.id]);

  if (suggestions.status === 'loading') return <SkeletonRows rows={3} />;
  if (suggestions.status === 'error') return <ErrorState error={suggestions.error} onRetry={suggestions.reload} />;

  const mine = suggestions.data.filter((s) => s.projectId === project.id);
  const pending = mine.filter((s) => s.status === 'PENDING');
  const decided = mine.filter((s) => s.status !== 'PENDING');

  return (
    <>
      <ReviewQueue
        pending={pending}
        canDecide={canDecide}
        onDecided={(msg) => {
          if (msg) toast.success(msg);
          suggestions.reload();
        }}
      />
      <DecidedList items={decided} />
    </>
  );
}
